module.exports = __webpack_public_path__ + "img/man.97e88b9d.png";